import {
  INVOICE_CREATE_FAIL,
  INVOICE_CREATE_REQUEST,
  INVOICE_CREATE_SUCCESS,
  INVOICE_DELETE_FAIL,
  INVOICE_DELETE_REQUEST,
  INVOICE_DELETE_RESET,
  INVOICE_DELETE_SUCCESS,
  INVOICE_DETAILS_FAIL,
  INVOICE_DETAILS_REQUEST,
  INVOICE_DETAILS_SUCCESS,
  INVOICE_GET_FAIL,
  INVOICE_GET_REQUEST,
  INVOICE_GET_SUCCESS,
  INVOICE_LIST_FAIL,
  INVOICE_LIST_REQUEST,
  INVOICE_LIST_SUCCESS,
  INVOICE_LIST_TOTAL_FAIL,
  INVOICE_LIST_TOTAL_REQUEST,
  INVOICE_LIST_TOTAL_SUCCESS,
  INVOICE_UPDATE_FAIL,
  INVOICE_UPDATE_REQUEST,
  INVOICE_UPDATE_SUCCESS,
} from "../constants/invoiceConstants";

export const invoiceListReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_LIST_REQUEST:
      return { loading: true };
    case INVOICE_LIST_SUCCESS:
      return { loading: false, invoices: action.payload };
    case INVOICE_LIST_FAIL:
      return { loading: false, error: action.payload, invoices: {} };
    default:
      return state;
  }
};

export const invoiceListTotalReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_LIST_TOTAL_REQUEST:
      return { loading: true };
    case INVOICE_LIST_TOTAL_SUCCESS:
      return { loading: false, invoicesTotal: action.payload };
    case INVOICE_LIST_TOTAL_FAIL:
      return { loading: false, error: action.payload, invoicesTotal: {} };
    default:
      return state;
  }
};

export const invoiceCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_CREATE_REQUEST:
      return { loading: true };
    case INVOICE_CREATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const invoiceDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_DETAILS_REQUEST:
      return { loading: true };
    case INVOICE_DETAILS_SUCCESS:
      return { loading: false, invoiceDetail: action.payload };
    case INVOICE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const invoiceDataReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_GET_REQUEST:
      return { loading: true, invoice: [] };
    case INVOICE_GET_SUCCESS:
      return { loading: false, invoice: action.payload };
    case INVOICE_GET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const invoiceUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_UPDATE_REQUEST:
      return { loading: true };
    case INVOICE_UPDATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const invoiceDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_DELETE_REQUEST:
      return { loading: true };
    case INVOICE_DELETE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_DELETE_RESET:
      return { success: "" };
    default:
      return state;
  }
};
